import { IconName } from '@optimus-web/icons';
import { SystemWideBannerVariant } from '@optimus-web/local-tokens';
import { Icon } from '../Icon';
import {
    SystemWideBannerContainer,
    SystemWideBannerIconElement,
    SystemWideBannerImportance,
    SystemWideBannerTextElement,
} from './style';

export interface SystemWideBannerProps {
    text: React.ReactNode;
    variant: SystemWideBannerVariant;
    showIcon?: boolean;
    centered?: boolean;
    importance?: SystemWideBannerImportance;
}

const SystemWideBanner = ({
    text,
    variant = 'info',
    showIcon,
    centered,
    importance = 'critical',
    ...other
}: SystemWideBannerProps) => (
    <SystemWideBannerContainer variant={variant} centered={centered} importance={importance} {...other}>
        {showIcon && (
            <SystemWideBannerIconElement>
                <Icon value={IconName.Info} variant={importance === 'urgent' ? variant : undefined} />
            </SystemWideBannerIconElement>
        )}
        <SystemWideBannerTextElement variant={variant} importance={importance}>
            {text}
        </SystemWideBannerTextElement>
    </SystemWideBannerContainer>
);

export default SystemWideBanner;
